export const de = {
    nav: {
        dashboard: 'Instrumententafel',
        board: 'Board',
        list: 'Liste',
        settings: 'Einstellungen',
        reports: 'Berichte',
        myTasks: 'Meine Aufgaben',
        activity: 'Aktivität',
        charts: 'Diagramme',
        team: 'Team',
        timeTracking: 'Zeiterfassung',
        admin: 'Admin',
        adminOverview: 'Admin-Übersicht',
        userManagement: 'Benutzerverwaltung',
        projectSetup: 'Projekteinrichtung',
    },
    common: {
        projectManMD: 'ProjectManMD',
        markdownProjectManagement: 'Markdown-Projektmanagement',
        version: 'Version',
        back: 'Zurück',
        loading: 'Laden...',
        noData: 'Keine Daten',
        search: 'Suchen',
        filter: 'Filter',
        all: 'Alle',
        close: 'Schließen',
        open: 'Öffnen',
        connect: 'Verbinden',
        archived: 'Archiviert',
        inactive: 'Inaktiv',
        active: 'Aktiv',
        untitled: 'Ohne Titel',
        unknown: 'Unbekannt',
        tasks: 'Aufgaben',
        done: 'Erledigt',
        lastModified: 'Zuletzt geändert',
        created: 'Erstellt',
        points: 'Punkte',
        pts: 'ptr',
        yes: 'Ja',
        no: 'Nein',
        or: 'oder',
    },
    actions: {
        create: 'Erstellen',
        edit: 'Bearbeiten',
        delete: 'Löschen',
        save: 'Speichern',
        cancel: 'Abbrechen',
        confirm: 'Bestätigen',
        add: 'Hinzufügen',
        remove: 'Entfernen',
        update: 'Aktualisieren',
        close: 'Schließen',
        submit: 'Senden',
        reset: 'Zurücksetzen',
        load: 'Laden',
        export: 'Exportieren',
        import: 'Importieren',
        archive: 'Archivieren',
        restore: 'Wiederherstellen',
        deactivate: 'Deaktivieren',
        activate: 'Aktivieren',
    },
    auth: {
        signIn: 'Anmelden',
        signOut: 'Abmelden',
        signUp: 'Registrieren',
        username: 'Benutzername',
        password: 'Passwort',
        confirmPassword: 'Passwort bestätigen',
        displayName: 'Anzeigename',
        email: 'E-Mail',
        role: 'Rolle',
        createAccount: 'Konto erstellen',
        dontHaveAccount: 'Noch kein Konto?',
        alreadyHaveAccount: 'Bereits ein Konto?',
        signInToAccount: 'Melden Sie sich an Ihrem Konto an',
        createYourAccount: 'Erstellen Sie Ihr Konto',
        enterUsername: 'Geben Sie Ihren Benutzernamen ein',
        enterPassword: 'Geben Sie Ihr Passwort ein',
        chooseUsername: 'Wählen Sie einen Benutzernamen',
        yourFullName: 'Ihr vollständiger Name',
        atLeast6Chars: 'Mindestens 6 Zeichen',
        confirmPasswordPlaceholder: 'Bestätigen Sie Ihr Passwort',
        pleaseEnterCredentials: 'Bitte geben Sie Benutzernamen und Passwort ein',
        invalidCredentials: 'Ungültiger Benutzername oder Passwort',
        pleaseFillAllFields: 'Bitte füllen Sie alle Felder aus',
        passwordsDoNotMatch: 'Passwörter stimmen nicht überein',
        passwordTooShort: 'Das Passwort muss mindestens 6 Zeichen haben',
        usernameExists: 'Benutzername existiert bereits',
        demoCredentials: 'Demo-Anmeldedaten',
        admin: 'Admin',
        manager: 'Manager',
        developer: 'Entwickler',
        viewer: 'Betrachter',
        contactAdminForRole: 'Kontaktieren Sie den Admin für Rollenänderung',
        usernameCannotBeChanged: 'Benutzername kann nicht geändert werden',
    },
    statuses: {
        backlog: 'Backlog',
        todo: 'Zu erledigen',
        inProgress: 'In Bearbeitung',
        inReview: 'In Überprüfung',
        done: 'Erledigt',
        planned: 'Geplant',
        inProgressSprint: 'In Bearbeitung (Sprint)',
        completed: 'Abgeschlossen',
        allStatus: 'Alle Status',
    },
    priorities: {
        critical: 'Kritisch',
        high: 'Hoch',
        medium: 'Mittel',
        low: 'Niedrig',
    },
    messages: {
        noProjects: 'Noch keine Projekte',
        noTasks: 'Keine Aufgaben',
        confirmDelete: 'Sind Sie sicher, dass Sie dies löschen möchten?',
        saved: 'Erfolgreich gespeichert',
        error: 'Ein Fehler ist aufgetreten',
        noTasksAssigned: 'Keine Aufgaben sind Ihnen zugewiesen',
        noActivityYet: 'Noch keine Aktivität',
        confirmReset: 'Dadurch werden alle Daten auf die Beispielstate zurückgesetzt. Fortfahren?',
        removeUserConfirm: 'Sind Sie sicher, dass Sie diesen Benutzer entfernen möchten?',
        deleteProjectConfirm: 'Sind Sie sicher, dass Sie dieses Projekt löschen möchten?',
        archiveProjectConfirm: 'Sind Sie sicher, dass Sie dieses Projekt archivieren möchten?',
    },
    settings: {
        title: 'Einstellungen',
        theme: 'Design',
        language: 'Sprache',
        languageAndRegion: 'Sprache & Region',
        gitConfig: 'Git-Konfiguration',
        gitIntegration: 'Git-Integration',
        gitProvider: 'Git-Anbieter',
        repositoryUrl: 'Repository-URL',
        seedData: 'Beispieldaten',
        seedDataDescription: 'Laden Sie Beispielprojekte mit Aufgaben, Sprints und Epics für Tests.',
        loadSeedData: 'Beispieldaten laden',
        seedDataConfirm: 'Dadurch werden alle Daten auf die Beispielstate zurückgesetzt. Fortfahren?',
        appearance: 'Erscheinungsbild',
        notifications: 'Benachrichtigungen',
    },
    themes: {
        summer: 'Sommer',
        spring: 'Frühling',
        autumn: 'Herbst',
        winter: 'Winter',
        day: 'Tag',
        night: 'Nacht',
        summerDay: 'Sommertag',
        summerNight: 'Sommerabend',
        springDay: 'Frühlingstag',
        springNight: 'Frühlingsnacht',
        autumnDay: 'Herbsttag',
        autumnNight: 'Herbstnacht',
        winterDay: 'Wintertag',
        winterNight: 'Winterabend',
        highContrast: 'Hoher Kontrast',
        selectTheme: 'Design auswählen',
    },
    time: {
        hours: 'Stunden',
        minutes: 'Minuten',
        days: 'Tage',
        weeks: 'Wochen',
        justNow: 'gerade eben',
        minutesAgo: '{{count}}m ago',
        hoursAgo: '{{count}}h ago',
        daysAgo: '{{count}}d ago',
        updatedAt: 'Aktualisiert',
    },
    reports: {
        velocity: 'Geschwindigkeit',
        burndown: 'Burndown',
        burnup: 'Burnup',
        cycleTime: 'Zykluszeit',
        leadTime: 'Bearbeitungszeit',
        throughput: 'Durchsatz',
        gantt: 'Gantt',
        cumulativeFlow: 'Kumulierter Fluss',
    },
    globalSearch: {
        placeholder: 'Projekte, Aufgaben, Sprints suchen...',
        noResults: 'Keine Ergebnisse gefunden',
        projects: 'Projekte',
        tasks: 'Aufgaben',
        sprints: 'Sprints',
        epics: 'Epics',
    },
    notifications: {
        title: 'Benachrichtigungen',
        markAllRead: 'Alle als gelesen markieren',
        clearAll: 'Alle löschen',
        empty: 'Keine Benachrichtigungen',
        unread: '{count} ungelesen',
    },
    dashboard: {
        totalProjects: 'Gesamtprojekte',
        totalTasks: 'Gesamtaufgaben',
        completion: 'Abschluss',
        statusBreakdown: 'Statusaufschlüsselung',
        createProject: 'Projekt erstellen',
        loadSeedData: 'Beispieldaten laden',
        noProjects: 'Noch keine Projekte',
        getStarted: 'Erstellen Sie ein neues Projekt oder laden Sie Beispieldaten.',
        projects: 'Projekte',
        newProject: 'Neues Projekt',
        createNewProject: 'Neues Projekt erstellen',
        projectName: 'Projektname',
        description: 'Beschreibung',
        workflow: 'Workflow',
        skipToMain: 'Zum Hauptinhalt springen',
        projectProgress: 'Projektfortschritt',
        quickActions: 'Quick Actions',
        manageTasks: 'Manage tasks and track progress',
        trackTime: 'Track time for your tasks',
    },
    calendar: {
        jalali: 'Djalali',
        hijri: 'Hidschri',
        gregorian: 'Gregorianisch',
    },
    accessibility: {
        skipToMain: 'Zum Hauptinhalt springen',
        board: 'Aufgabenboard',
        projectList: 'Projektliste',
        mainNav: 'Hauptnavigation',
        selectTheme: 'Design auswählen',
        projectDashboard: 'Projektdashboard',
        toggleSidebar: 'Toggle sidebar',
    },
    board: {
        title: 'Board',
        kanban: 'Kanban',
        scrum: 'Scrum',
    },
    task: {
        title: 'Aufgabe',
        createTask: 'Aufgabe erstellen',
        editTask: 'Aufgabe bearbeiten',
        deleteTask: 'Aufgabe löschen',
        assignee: 'Zugewiesen an',
        unassigned: 'Nicht zugewiesen',
        storyPoints: 'Story-Punkte',
        labels: 'Etiketten',
        description: 'Beschreibung',
        acceptanceCriteria: 'Akzeptanzkriterien',
        timeLog: 'Zeiterfassung',
        comments: 'Kommentare',
        addComment: 'Kommentar hinzufügen',
        noComments: 'Noch keine Kommentare',
        status: 'Status',
        priority: 'Priorität',
        created: 'Erstellt',
        updated: 'Aktualisiert',
        started: 'Gestartet',
    },
    sprint: {
        title: 'Sprint',
        createSprint: 'Sprint erstellen',
        sprintGoal: 'Sprint-Ziel',
        committedPoints: 'Zugesagte Punkte',
        completedPoints: 'Abgeschlossene Punkte',
        velocity: 'Geschwindigkeit',
        planned: 'Geplant',
        inProgress: 'In Bearbeitung',
        completed: 'Abgeschlossen',
    },
    team: {
        title: 'Team',
        members: 'Mitglieder',
        role: 'Rolle',
        availability: 'Verfügbarkeit',
        assignedTasks: 'Zugewiesene Aufgaben',
        activeTasks: 'Aktive Aufgaben',
        doneTasks: 'Erledigte Aufgaben',
    },
    timeTracking: {
        title: 'Zeiterfassung',
        timer: 'Timer',
        manualEntry: 'Manuelle Eingabe',
        startTime: 'Startzeit',
        stopTime: 'Stopzeit',
        duration: 'Dauer',
        date: 'Datum',
        totalHours: 'Gesamtstunden',
        entries: 'Einträge',
        noEntries: 'Noch keine Einträge',
        hours: 'Hours',
        minutes: 'Minutes',
    },
    admin: {
        dashboard: 'Admin-Dashboard',
        projects: 'Projekte',
        totalTasks: 'Gesamtaufgaben',
        storyPoints: 'Story-Punkte',
        taskStatusBreakdown: 'Aufgabenstatus-Zusammenfassung',
        projectProgress: 'Projektfortschritt',
        teamWorkload: 'Team-Belastung',
        assigned: 'Zugewiesen',
        active: 'Aktiv',
    },
    myTasks: {
        title: 'Meine Aufgaben',
        total: 'Gesamt',
        inProgress: 'In Bearbeitung',
        inReview: 'In Überprüfung',
        done: 'Erledigt',
        completion: 'Fertigstellung',
        allStatus: 'Alle Status',
        allProjects: 'Alle Projekte',
        noTasksAssigned: 'Keine Aufgaben sind Ihnen zugewiesen',
    },
    activity: {
        title: 'Aktivitäts-Feed',
        commentsOnYourTasks: 'Kommentare zu Ihren Aufgaben',
        allActivity: 'Gesamte Aktivität',
        noActivityYet: 'Noch keine Aktivität',
        commentedOn: 'hat kommentiert auf',
        movedTo: 'hat verschoben nach',
    },
    profile: {
        title: 'Profil',
        avatar: 'Avatar',
        dragDropImage: 'Ziehen und ablegen Sie ein Bild hierher, oder wählen Sie eine Datei',
        browse: 'Durchsuchen',
        imageFormats: 'PNG, JPG, WEBP bis zu 2 MB',
        removePhoto: 'Foto entfernen',
        saveChanges: 'Änderungen speichern',
        profileSaved: 'Profil gespeichert',
        contactAdmin: 'Kontaktieren Sie den Admin für Rollenänderung',
    },
};
//# sourceMappingURL=de.js.map